import React, { lazy } from 'react';
import MiniprogramApiIcon from '@/assets/images/menu/icon-hippy-api.react.svg?react';
import MiniprogramErrorIcon from '@/assets/images/menu/icon-hippy-error.react.svg?react';
import MiniprogramEventIcon from '@/assets/images/menu/icon-hippy-event.react.svg?react';
import MiniprogramLogIcon from '@/assets/images/menu/icon-hippy-log.react.svg?react';
import MiniprogramPerfIcon from '@/assets/images/menu/icon-hippy-perf.react.svg?react';
import MiniprogramPvIcon from '@/assets/images/menu/icon-hippy-pv.react.svg?react';
import MiniprogramSpeedIcon from '@/assets/images/menu/icon-hippy-speed.react.svg?react';
import MiniprogramStaticIcon from '@/assets/images/menu/icon-hippy-static.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';


export const miniProgramRoutes = (): IRouteConfig[] => [
  {
    path: '/mini-program/error',
    name: '错误监控',
    component: lazy(() => import('@/presentation/pages/mini-program/error')),
    icon: <MenuIcon icon={MiniprogramErrorIcon} fontSize={16} />,
    platforms: [CapitalPlatform.MiniProgram],
    sort: 100,
  },
  {
    path: '/mini-program/api',
    name: 'API监控',
    icon: <MenuIcon icon={MiniprogramApiIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/mini-program/api')),
    platforms: [CapitalPlatform.MiniProgram],
    sort: 99,
  },
  {
    path: '/mini-program/static',
    name: '静态资源',
    icon: <MenuIcon icon={MiniprogramStaticIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/mini-program/static')),
    platforms: [CapitalPlatform.MiniProgram],
    sort: 98,
  },
  {
    path: '/performance',
    name: '性能监控',
    icon: <MenuIcon icon={MiniprogramPerfIcon} fontSize={16} />,
    platforms: [CapitalPlatform.MiniProgram],
    sort: 97,
    routes: [
      {
        path: '/mini-program/launch',
        name: '启动性能',
        component: lazy(() => import('@/presentation/pages/mini-program/launch')),
      },
      {
        path: '/mini-program/perf',
        name: '页面性能',
        component: lazy(() => import('@/presentation/pages/mini-program/perf')),
      },
      {
        path: '/mini-program/runtime',
        name: '运行性能',
        component: lazy(() => import('@/presentation/pages/mini-program/runtime')),
      },
    ],
  },
  {
    path: '/mini-program/pv',
    name: '页面访问',
    icon: <MenuIcon icon={MiniprogramPvIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/mini-program/pv')),
    platforms: [CapitalPlatform.MiniProgram],
    sort: 96,
  },
  {
    path: '/mini-program/event',
    name: '自定义事件',
    icon: <MenuIcon icon={MiniprogramEventIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/mini-program/event')),
    platforms: [CapitalPlatform.MiniProgram],
    sort: 95,
  },
  {
    path: '/mini-program/custom',
    name: '自定义测速',
    icon: <MenuIcon icon={MiniprogramSpeedIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/mini-program/custom')),
    platforms: [CapitalPlatform.MiniProgram],
    sort: 94,
  },
  {
    path: '/mini-program/log',
    name: '日志',
    icon: <MenuIcon icon={MiniprogramLogIcon} fontSize={16} />,
    component: lazy(() => import('@/presentation/pages/mini-program/log')),
    platforms: [CapitalPlatform.MiniProgram],
    sort: 93,
  },
];

export default miniProgramRoutes;
